// Lock-In session maths. Time is always worked out from an end timestamp, never from counting ticks, so a
// phone that sleeps or a tab that is throttled still shows the right time when it wakes.
export const DURATIONS = [15, 25, 45];
export const DEFAULT_MINUTES = 25;

export const remainingSeconds = (endAt, now = Date.now()) => Math.max(0, Math.ceil((endAt - now) / 1000));

// 0 at the start, 1 when the time is up.
export function progressFraction(endAt, minutes, now = Date.now()) {
  const total = minutes * 60;
  if (!(total > 0)) return 1;
  const done = 1 - remainingSeconds(endAt, now) / total;
  return Math.min(1, Math.max(0, done));
}

// 1500 -> "25:00", 65 -> "1:05"
export function formatClock(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, "0")}`;
}

export const startLabel =(minutes) => `Start ${minutes} minutes`;
